import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DataTypeSelectorProps } from './FieldsSettingsTypes';

const SelectStyled = styled(Select)(() => ({
  width: 'calc(100% - 10px)',
  '& .MuiSelect-select': {
    textTransform: 'capitalize',
  },
}));

const MenuItemStyled = styled(MenuItem)({
  textTransform: 'capitalize',
});

const DataTypeSelector = ({
  dataTypesResponse,
  dropdownChange,
  fieldDataType,
}: DataTypeSelectorProps): JSX.Element => {
  const dataTypes = [dataTypesResponse].flat();

  return (
    <SelectStyled
      data-cy="data-type-selector"
      id="data-type-selector"
      labelId="data-type-selector-label"
      onChange={dropdownChange}
      value={fieldDataType}
    >
      {dataTypes.map((data, index) => (
        <MenuItemStyled
          id="data-type-selector-item"
          data-cy="data-type-selector-item"
          key={index}
          value={data?.name}
        >
          {data?.name}
        </MenuItemStyled>
      ))}
    </SelectStyled>
  );
};

export default DataTypeSelector;
